import { render, staticRenderFns } from "./scaleBox.vue?vue&type=template&id=590dc964&scoped=true"
import script from "./scaleBox.vue?vue&type=script&lang=js"
export * from "./scaleBox.vue?vue&type=script&lang=js"
import style0 from "./scaleBox.vue?vue&type=style&index=0&id=590dc964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590dc964",
  null
  
)

export default component.exports